export const USERROLE = {
  AUCTIONER: "auctioneer",
  BIDDER: "bidder",
};
